// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./themes.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-button {
    position: fixed;
    bottom: 3.5rem;
    right:4rem;
    background-color: var(--primary);
    border-radius: 50%;
    width:3rem;
    height: 3rem;
    font-size: 2rem;
    text-align: center;
    align-items: center;
    transition: background 0.5s;
    color: var(--text)
}

.create-button:hover {
    background-color: var(--secondary);
}

.film {
    position:fixed;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.4);
    height: 100%;
    width: 100%;
    display: flex;
    justify-content:center;
    align-items: center;
}

.form-panel {
    display: block;
    min-height: 35rem;
    width:40%;
    height:85%;
    background-color: var(--form-background);
    border-radius: 5rem;
    padding:2rem;
}

form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap:2rem;
}

.text-input,.title-input,.dropdown,.submit-button, .date-input {
    font-family: 'Poppins', sans-serif;
    font-size: 2rem;
    border-radius: 2rem;
    border: none;
    color: var(--text);
    outline: none;
    transition: border 100ms;
    width: 90%;
    max-width: 90%;
}

.text-input {
    height: 300px;
    padding-left: 2rem;
    background-color: var(--form-primary);
    margin: 2%;
}

.title-input {
    height: 4rem;
    padding-left: 2rem;
    background-color: var(--form-primary);
    margin: 2%;
}

.text-input:focus, .title-input:focus {
    border: 2px solid var(--secondary);
}


.grid {
    display: grid;
    margin-left: 2%;
    row-gap: 3vh;
    column-gap: 3vw;
    grid-template-columns: repeat(2,1fr);
    grid-template-rows: repeat(2,1fr);
}

.dropdown, .submit-button, .date-input {
    width: 10vw;
    height: 2.5rem;
    font-size: 1rem;
    background-color: var(--form-secondary);
    cursor: pointer;
}
.dropdown {
    padding-left: 1rem;
}

.star-input {
    font-size: 2rem;
    text-align: center;
    cursor: pointer;
    color: var(--text);
}

.star-input:hover {
    fill: gold;
}

.date-input {
    padding-left: 1rem;
}

.pro-pri {
    display: flex;
    gap:3vw;
}`, "",{"version":3,"sources":["webpack://./src/styles/form.css"],"names":[],"mappings":"AAIA;IACI,eAAe;IACf,cAAc;IACd,UAAU;IACV,gCAAgC;IAChC,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,UAAU;IACV,oCAAoC;IACpC,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,wCAAwC;IACxC,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,wBAAwB;IACxB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,qCAAqC;IACrC,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,UAAU;AACd;;AAEA;IACI,kCAAkC;AACtC;;;AAGA;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,eAAe;IACf,oCAAoC;IACpC,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,cAAc;IACd,eAAe;IACf,uCAAuC;IACvC,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,OAAO;AACX","sourcesContent":["@import url(./themes.css);\r\n\r\n\r\n\r\n.create-button {\r\n    position: fixed;\r\n    bottom: 3.5rem;\r\n    right:4rem;\r\n    background-color: var(--primary);\r\n    border-radius: 50%;\r\n    width:3rem;\r\n    height: 3rem;\r\n    font-size: 2rem;\r\n    text-align: center;\r\n    align-items: center;\r\n    transition: background 0.5s;\r\n    color: var(--text)\r\n}\r\n\r\n.create-button:hover {\r\n    background-color: var(--secondary);\r\n}\r\n\r\n.film {\r\n    position:fixed;\r\n    z-index: 1;\r\n    background-color: rgba(0, 0, 0, 0.4);\r\n    height: 100%;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content:center;\r\n    align-items: center;\r\n}\r\n\r\n.form-panel {\r\n    display: block;\r\n    min-height: 35rem;\r\n    width:40%;\r\n    height:85%;\r\n    background-color: var(--form-background);\r\n    border-radius: 5rem;\r\n    padding:2rem;\r\n}\r\n\r\nform {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap:2rem;\r\n}\r\n\r\n.text-input,.title-input,.dropdown,.submit-button, .date-input {\r\n    font-family: 'Poppins', sans-serif;\r\n    font-size: 2rem;\r\n    border-radius: 2rem;\r\n    border: none;\r\n    color: var(--text);\r\n    outline: none;\r\n    transition: border 100ms;\r\n    width: 90%;\r\n    max-width: 90%;\r\n}\r\n\r\n.text-input {\r\n    height: 300px;\r\n    padding-left: 2rem;\r\n    background-color: var(--form-primary);\r\n    margin: 2%;\r\n}\r\n\r\n.title-input {\r\n    height: 4rem;\r\n    padding-left: 2rem;\r\n    background-color: var(--form-primary);\r\n    margin: 2%;\r\n}\r\n\r\n.text-input:focus, .title-input:focus {\r\n    border: 2px solid var(--secondary);\r\n}\r\n\r\n\r\n.grid {\r\n    display: grid;\r\n    margin-left: 2%;\r\n    row-gap: 3vh;\r\n    column-gap: 3vw;\r\n    grid-template-columns: repeat(2,1fr);\r\n    grid-template-rows: repeat(2,1fr);\r\n}\r\n\r\n.dropdown, .submit-button, .date-input {\r\n    width: 10vw;\r\n    height: 2.5rem;\r\n    font-size: 1rem;\r\n    background-color: var(--form-secondary);\r\n    cursor: pointer;\r\n}\r\n.dropdown {\r\n    padding-left: 1rem;\r\n}\r\n\r\n.star-input {\r\n    font-size: 2rem;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    color: var(--text);\r\n}\r\n\r\n.star-input:hover {\r\n    fill: gold;\r\n}\r\n\r\n.date-input {\r\n    padding-left: 1rem;\r\n}\r\n\r\n.pro-pri {\r\n    display: flex;\r\n    gap:3vw;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
